import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { goBack, push } from 'react-router-redux';
import { FontIcon } from 'material-ui';
import R from 'ramda';

import {
  getAvailDocsForDiffReport as getAvailDocsForDiffReportAction,
  clearStore as clearStoreAction,
} from '../../../stores/contracting-reports/actions';

const propTypes = {
  generatingReport: PropTypes.bool,
  params: PropTypes.object,
  goBack: PropTypes.func,
  getAvailDocsForDiffReport: PropTypes.func,
  clearStore: PropTypes.func,
};

class DiffReportContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
    const { collection } = this.props.params;
    const { locationId, buyerId, email } = this.props.location.query;
    if (locationId) {
      this.props.getAvailDocsForDiffReport({ collection, locationId, buyerId, email })
    }
  }
  shouldComponentUpdate(nextProps, nextState) {
    const propKeys = R.keys(propTypes).filter(key => propTypes[key] !== PropTypes.func);
    return !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps)) || !R.equals(this.state, nextState);
  }
  componentWillUnmount() {
    this.props.clearStore();
  }

  onClickGoBack = () => {
    if (window.history && window.history.length > 1) {
      return this.props.goBack();
    }
    window.close();
  };

  render() {
    const { children } = this.props;
    return (
      <div className="full-screen-page" >
        {children}
        <div
          style={{ position: 'fixed', top: 6, right: 16, cursor: 'pointer', zIndex: 20 }}
          onClick={this.onClickGoBack}
        >
          <FontIcon className="tc-icon-close" style={{ fontSize: '36px', color: 'rgba(0, 0, 0, 0.54)' }} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ }) => ({
});

const mapDispatchToProps = ({
  goBack,
  push,
  getAvailDocsForDiffReport: getAvailDocsForDiffReportAction,
  clearStore: clearStoreAction,
});
DiffReportContainer.propTypes = propTypes;
DiffReportContainer.contextTypes = {
  router: PropTypes.object.isRequired,
};
export default connect(mapStateToProps, mapDispatchToProps)(DiffReportContainer);




// WEBPACK FOOTER //
// ./src/app/components/contracting-reports/diff-report/router.jsx